import { render, staticRenderFns } from "./AppRelatedSection.vue?vue&type=template&id=7ec3581e&"
import script from "./AppRelatedSection.vue?vue&type=script&lang=js&"
export * from "./AppRelatedSection.vue?vue&type=script&lang=js&"
import style0 from "./AppRelatedSection.vue?vue&type=style&index=0&id=7ec3581e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports